'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_LeftMenu$MenuItem(title, icon, links, test, always, feature, isNew) {
  this.CJ = null;
  this.CG = null;
  this.CI = null;
  this.wX = null;
  this.CE = false;
  this.CF = null;
  this.CH = false;
  this.CJ = title;
  this.CG = icon;
  this.CI = links;
  this.wX = test;
  this.CE = always;
  this.CF = feature;
  this.CH = isNew;
}
export { $c_Lpresto_LeftMenu$MenuItem as $c_Lpresto_LeftMenu$MenuItem };
$p = $c_Lpresto_LeftMenu$MenuItem.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LeftMenu$MenuItem;
/** @constructor */
function $h_Lpresto_LeftMenu$MenuItem() {
}
export { $h_Lpresto_LeftMenu$MenuItem as $h_Lpresto_LeftMenu$MenuItem };
$h_Lpresto_LeftMenu$MenuItem.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("MenuItem"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.CJ));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.CG));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.CI));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.wX));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.CE ? 1231 : 1237));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.CF));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.CH ? 1231 : 1237));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().al(acc, 7);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_LeftMenu$MenuItem)) {
    if ((((this.CE === x$0.CE) && (this.CH === x$0.CH)) && (this.CJ === x$0.CJ))) {
      var x = this.CG;
      var x$2 = x$0.CG;
      var $x_3 = (x === x$2);
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.CI;
      var x$4 = x$0.CI;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.wX;
      var x$6 = x$0.wX;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.CF;
      var x$8 = x$0.CF;
      return ((x$7 === null) ? (x$8 === null) : x$7.i(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 7;
});
$p.s = (function() {
  return "MenuItem";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.CJ;
      break;
    }
    case 1: {
      return this.CG;
      break;
    }
    case 2: {
      return this.CI;
      break;
    }
    case 3: {
      return this.wX;
      break;
    }
    case 4: {
      return this.CE;
      break;
    }
    case 5: {
      return this.CF;
      break;
    }
    case 6: {
      return this.CH;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_LeftMenu$MenuItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ix)));
}
export { $isArrayOf_Lpresto_LeftMenu$MenuItem as $isArrayOf_Lpresto_LeftMenu$MenuItem };
var $d_Lpresto_LeftMenu$MenuItem = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LeftMenu$MenuItem, "presto.LeftMenu$MenuItem", ({
  ix: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_LeftMenu$MenuItem as $d_Lpresto_LeftMenu$MenuItem };
//# sourceMappingURL=presto.-Left-Menu$-Menu-Item.js.map
